import { render, staticRenderFns } from "./IntegrationLogo.vue?vue&type=template&id=87b79d4a&scoped=true&"
import script from "./IntegrationLogo.vue?vue&type=script&lang=ts&"
export * from "./IntegrationLogo.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationLogo.vue?vue&type=style&index=0&id=87b79d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b79d4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
